import { useMemo } from 'react';
import { gqlGenderAppearanceEnum as GENDER_APPEARANCE } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';

export const useGenderOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { value: GENDER_APPEARANCE.MAN, label: t('common:label.gender.man') },
      { value: GENDER_APPEARANCE.WOMAN, label: t('common:label.gender.woman') },
      { value: GENDER_APPEARANCE.NON_BINARY_PERSON, label: t('common:label.gender.nonBinaryPerson') },
      { value: GENDER_APPEARANCE.TRANS_MAN, label: t('common:label.gender.transMan') },
      { value: GENDER_APPEARANCE.TRANS_WOMAN, label: t('common:label.gender.transWoman') },
    ],
    [t]
  );
};
